import { ReversalHistoryKey } from '../../TModules';

export const translations = {
  [ReversalHistoryKey]: {
    Title: 'Stornierungsverlauf',
    Administrator: 'Administrator',
    Source: 'Quelle',
    SourceTransactionReversal: 'Transaktionsstornierung',
    SourceBulkAction: 'Massenaktion',
    StatusSuccess: 'Erfolgreich',
    StatusFailed: 'Fehlgeschlagen',
    ExportCsv: 'CSV exportieren',
    Campaign: 'Kampagne',
    TicketCode: 'Ticket-Code',
    Customer: 'Kunde',
    Reason: 'Grund',
    Outcome: 'Ergebnis',
    FailureMessage: 'Fehlermeldung',
    ReversedOn: 'Storniert am',
    System: 'System',
    FilterCampaign: 'Nach Kampagne filtern',
    FilterAdministrator: 'Nach Administrator filtern',
    FilterSource: 'Nach Quelle filtern',
    FilterOutcome: 'Nach Ergebnis filtern',
    ExportQueued: 'Export in Warteschlange — wir senden die CSV-Datei an {{email}}'
  }
};
